export default __webpack_public_path__ + "static/media/money-coin.8337dbd4.svg";